import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getSublet, getSublets } from "../services/sublet";

export function useGetSublets() {
  return useQuery({
    queryKey: ["sublets"],
    queryFn: () => getSublets(),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetSublet(id: string) {
  return useQuery({
    queryKey: ["sublet", id],
    queryFn: () => getSublet(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
